import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { BannerCardContainer } from '../banner-card-container';
import SmartLink from '../../../../link';

import * as styles from './index.module.scss';

/**
  Export the banner cards
 * @param object data
 * @returns 
 */
export const BannerCardType = (props) => {
  let { 
    backgroundColour,
    backgroundImage,
    template,
    textColourSelect,
    buttonUrl,
    openInANewTab,
    buttonFile,
    style,
    padding,
    isProduct
  } = props;

  if(!backgroundImage)
    backgroundImage = props?.image;

  if(!buttonUrl)
    buttonUrl = props?.url;

  if (buttonFile && buttonFile.publicUrl)
    buttonUrl = buttonFile.publicUrl;

  let cardClass = isProduct ? `${styles.card} ${styles.half}` : `${styles.card}`;
  let colourClass = (textColourSelect !== false) ? `${styles.whiteColour}` : ``;
  let accordionClass = (template === 'Accordion') ? `${styles.accordionNoPadding}` : ``;

  let isAccordionTemplate = template === 'Accordion';
  let defaultAccordionColor = '#f5f5f5'; 

  if (style === 'tall')
    cardClass += ' ' + styles.tall;

  padding = padding?.replace(' ', '');

  cardClass += ' ' + (padding ? styles[padding?.toLowerCase()] : styles['small']);

  if ([
    'Image Only'
  ].includes(template))
    return (
      <div
        className={`${cardClass} ${colourClass}`}
      >
        {backgroundImage?.gatsbyImageData ? (
          <GatsbyImage image={getImage(backgroundImage)} alt={backgroundImage.alt || backgroundImage.title || ''} />
        ) : (
          <img src={backgroundImage?.url} alt={backgroundImage?.alt || ''} />
        )}
      </div>
    );

  if ([
    'Trustpilot',
    'Accordion',
    'Form',
    'Product Description',
    'Product Features',
    'Footer Form'
  ].includes(template))
    return (
      <div
        className={`${cardClass} ${colourClass} ${accordionClass}`}
      >
        {backgroundImage?.gatsbyImageData && (
          <div className={styles.backgroundImage}>
            <GatsbyImage image={getImage(backgroundImage)} alt={backgroundImage.title || ''} />
          </div>
        )}
        <div
          className={styles.overlay}
          style={{
            backgroundColor: (isAccordionTemplate && (!backgroundColour || backgroundColour.length > 0)) ? defaultAccordionColor : backgroundColour
          }}
        ></div>
        <BannerCardContainer {...props} />
      </div>
    );

  const CardContent = () => (
    <>
      {backgroundImage?.gatsbyImageData && (
        <div className={styles.backgroundImage}>
          <GatsbyImage image={getImage(backgroundImage)} alt={backgroundImage.title || ''} />
        </div>
      )}
      <div
        className={styles.overlay}
        style={{
          backgroundColor: (backgroundColour && backgroundColour.length > 0) ? backgroundColour : ''
        }}
      ></div>
      <BannerCardContainer {...props} />
    </>
  );

  if (!buttonUrl) {
    return (
      <div className={`${cardClass} ${colourClass}`}>
        <CardContent />
      </div>
    );
  }

  return (
    <SmartLink
      href={buttonUrl}
      className={`${cardClass} ${colourClass}`}
      target={openInANewTab ? '_blank' : '_self'}>
      <CardContent />
    </SmartLink>
  );
}
